const info = {
  es: {
    trabaja: 'Trabaja con Nosotros'

  },
  en: {
    trabaja: 'Work with Us'
  }
}

export default info;